import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {LoggedInView} from '../common/LoggedInView';
import Pagination from '../common/Pagination';
import {useAppDispatch, useAppSelector} from '../../utils/Hooks';
import {getInvoiceHistory} from '../../store/reducers/InvoiceHistorySlice';
import InvoiceHistorySearch from './components/InvoiceHistorySearch';
import {InvoiceHistoryTable} from './components/InvoiceHistoryTable';

export const InvoiceHistoryScreen: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const invoiceHistory = useAppSelector((state) => state.invoiceHistory);

    const params = new URLSearchParams(location.search);
    const perPage = parseInt(params.get('perPage') || '30', 10);

    useEffect(() => {
        const query = new URLSearchParams(location.search);

        dispatch(getInvoiceHistory({
            search: query.get('search') || '',
            sender: query.get('sender') || '',
            dateFrom: query.get('dateFrom') || '',
            dateTo: query.get('dateTo') || '',
            page: parseInt(query.get('p') || '1', 10),
            perPage: parseInt(query.get('perPage') || '30', 10),
        }));
    }, [dispatch, location.search]);

    return (
        <LoggedInView fullWidth={true}>
            <h1>Arvete ajalugu</h1>
            <InvoiceHistorySearch/>
            <InvoiceHistoryTable/>
            {invoiceHistory.total > 0 && (
                <Pagination totalItems={invoiceHistory.total} itemsPerPage={perPage}/>
            )}
        </LoggedInView>
    );
};
